export type RecordType = 'pee' | 'poop' | 'mixed'
export type DeviceRole = 'owner' | 'member'

export type DiaperColor =
  | 'yellow'
  | 'yellow_green'
  | 'dark_green'
  | 'green_brown'
  | 'light_yellow'
  | 'dark_brown'

export type DiaperTexture =
  | 'pasty'
  | 'dry'
  | 'creamy'
  | 'curd'
  | 'watery'
  | 'foamy'

export const DIAPER_COLORS: { value: DiaperColor; label: string; cssColor: string }[] = [
  { value: 'yellow', label: '黄色', cssColor: '#fde047' },
  { value: 'yellow_green', label: '黄绿色', cssColor: '#a3c93c' },
  { value: 'dark_green', label: '墨绿色', cssColor: '#1f5f2e' },
  { value: 'green_brown', label: '绿褐色', cssColor: '#5b6b3a' },
  { value: 'light_yellow', label: '淡黄色', cssColor: '#fef3c7' },
  { value: 'dark_brown', label: '暗色', cssColor: '#6b4423' },
]

export const DIAPER_TEXTURES: { value: DiaperTexture; label: string; emoji: string }[] = [
  { value: 'pasty', label: '糊状', emoji: '🌀' },
  { value: 'dry', label: '干稠', emoji: '🍞' },
  { value: 'creamy', label: '膏状', emoji: '🥛' },
  { value: 'curd', label: '奶瓣', emoji: '🥣' },
  { value: 'watery', label: '稀水样', emoji: '💧' },
  { value: 'foamy', label: '泡沫', emoji: '🫧' },
]

export interface Family {
  id: string
  name: string
  join_code?: string | null
  created_at: number
}

export interface Device {
  id: string
  family_id: string
  name: string
  relationship: 'father' | 'mother' | 'other' | null
  role: DeviceRole
  created_at: number
  last_seen_at: number | null
  revoked_at: number | null
}

export interface BabyRecord {
  id: string
  family_id: string
  device_id: string
  client_uuid: string
  type: RecordType
  color: DiaperColor | null
  texture: DiaperTexture | null
  occurred_at: number
  created_at: number
  note: string | null
  photo_id: string | null
  photo_signed_url?: string | null
  ai_summary: string | null
}

export interface Me {
  family: Family
  device: Device
  devices: Device[]
  ai_configured: boolean
  ai_vision_configured: boolean
  photos_enabled: boolean
  r2_usage_bytes: number
}

export interface InviteResult {
  token: string
  url: string
  expires_at: number
}

export interface ExportData {
  family: Family
  records: BabyRecord[]
  devices: Device[]
  exported_at: number
}

export interface Photo {
  id: string
  size_bytes: number
  uploaded_at: number
  url: string
}

export interface PhotoUploadResult {
  photo: Photo
  storage_warning: string | null
  new_usage_bytes: number
}

export interface AiQuota {
  allowed: boolean
  remaining: number
  limit: number
  used: number
}

export interface StatsResponse {
  period_days: number
  total: number
  by_type: { pee: number; poop: number; mixed: number }
  by_day: Record<string, { total: number; pee: number; poop: number; mixed: number }>
  by_hour: number[]
}
